import { Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { SearchRouteCardData } from '../../components/search-route-card/search-route-card-data';
import { UserTimeZoneNotify } from '../../domains/tz-notify/tz-notify';
import { TTripSeatchItem } from './types';

export const SearchRoutesResult = observer(
  ({ trips = [] }: { trips: TTripSeatchItem[] }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleBookTicket = ({ tripid }: { tripid: string }) => {
      const startStation = searchParams.get('startStation');
      const endStation = searchParams.get('endStation');

      const path = `/order-tickets?tripid=${tripid}&startStation=${startStation}&endStation=${endStation}`;

      return navigate(path);
    };

    return (
      <Stack spacing="sm">
        <UserTimeZoneNotify />

        {trips.map((trip) => (
          <SearchRouteCardData
            key={trip.id}
            trip={trip}
            onBookTiket={handleBookTicket}
          />
        ))}
      </Stack>
    );
  }
);
